import { createStore } from 'mipd';
import { UAParser } from 'ua-parser-js';

const providersStore = createStore();
const parser = new UAParser();

const getDevice = () => {
  const os = parser.getOS();
  const isIOS = os.name === 'iOS';
  const isAndroid = os.name === 'Android';

  const device = parser.getDevice();
  const isIPad = device.model === 'iPad';
  const isMobile = device.type === 'mobile';
  const isTablet = device.type === 'tablet';

  return {
    isIOS,
    isAndroid,
    isIPad,
    isMobile,
    isTablet,
  };
};

const isProviderExistsEIP6963 = () => {
  return Boolean(providersStore.findProvider({ rdns: 'io.metamask' }));
};

export const detector = () => {
  const { isMobile, isTablet } = getDevice();

  if (isMobile || isTablet) {
    return true;
  }

  return (
    isProviderExistsEIP6963() ||
    Boolean(
      globalThis.window?.ethereum?.isMetaMask ||
        globalThis.window?.ethereum?.providerMap?.has?.('MetaMask'),
    )
  );
};
